import { Paragraph } from '@eggplant/pattern-library'

const SauceLabsDataCenterRequiredInfo = () =>
  <Paragraph>
    Please select a data center to access this field
  </Paragraph>

export default SauceLabsDataCenterRequiredInfo
